/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useState, useCallback, useRef, useEffect } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import getAgGridHeight from "../../../../../utils/commonFunctions/getAgGridHeight";

import { Button } from "@material-ui/core";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { SelectedEmployeesGridProps } from "../../../../../@types/components/openEnrollmentProps.types";
import { Member } from "../../../../../@types/member.types";
import { handleDateCellRenderer } from "../../../../../utils/commonFunctions/cellRenderers";

const SelectedEmployeeGrid = ({ selectedEmployees, setSelectedEmployees, type }: SelectedEmployeesGridProps) => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [gridHeight, setGridHeight] = useState<string>("400px");
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const agGridRef = useRef<any>(null);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleEmployeeDeleteClick = useCallback(() => {
		const focusedCell = agGridRef.current.api.getFocusedCell();
		const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
		const { data } = row;
		const rowData: Member[] = [];
		agGridRef.current.api.forEachNode((node: any) => rowData.push(node.data));
		const filteredEmployees: Member[] = rowData.filter((employee: Member) => {
			return employee.SSN !== data.SSN;
		});
		setSelectedEmployees(Object.assign([], filteredEmployees));
	}, [setSelectedEmployees]);

	const handleActionCellRender = () => {
		return (
			<Button className="ag-grid-cell-button " variant="outlined" onClick={handleEmployeeDeleteClick}>
				Delete
			</Button>
		);
	};

	useEffect(() => {
		const _gridHeight = getAgGridHeight(selectedEmployees.length);
		setGridHeight(_gridHeight);
	}, [selectedEmployees.length]);

	return (
		<div className="selected-employee-grid-conatiner grid-margin">
			<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
				<AgGridReact
					ref={agGridRef}
					rowData={selectedEmployees}
					onGridReady={handleAgGridReady}
					onFirstDataRendered={handleFirstDataRendered}
					rowSelection={"single"}
					defaultColDef={{
						resizable: true
					}}
					frameworkComponents={{
						handleActionCellRender: handleActionCellRender,
						handleDateCellRenderer: handleDateCellRenderer
					}}
				>
					<AgGridColumn field="member_id" headerName="Employee ID" suppressSizeToFit={true}></AgGridColumn>
					<AgGridColumn field="first_name" headerName="First Name" suppressSizeToFit={true}></AgGridColumn>
					<AgGridColumn field="last_name" headerName="Last Name" suppressSizeToFit={true}></AgGridColumn>
					<AgGridColumn
						field="date_of_birth"
						cellRenderer="handleDateCellRenderer"
						headerName="Date Of Birth"
					></AgGridColumn>
					<AgGridColumn field="SSN" headerName="SSN"></AgGridColumn>
					{type === "SPECIFIC" ? (
						<AgGridColumn
							field="action"
							headerName="Action"
							suppressSizeToFit={true}
							cellRenderer="handleActionCellRender"
						></AgGridColumn>
					) : null}
				</AgGridReact>
			</div>
		</div>
	);
};

export default SelectedEmployeeGrid;
